import { Box, Grid, Typography, styled } from "@mui/material";
import { AppImages } from "app/appImages";
import { AssessmentInstanceDto, AssessmentMode, AssessmentPlayerMode } from "generated/CoreApi_v1";
import HtmlUtils from "lib/HtmlUtils";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AssPlayerTitleHeader } from "views/assessment/player/common/AssPlayerTitleHeader";

interface IProps {
    viewData: AssessmentInstanceDto;
    fullScreenMode: boolean;
}

const ContainerMessage = styled(Box)(
    ({ theme }) => ({
        margin: 0,
        padding: 0,
        "& > ul": {
            margin: 0,
            padding: "1 0 0 0",
        },
        "& > p": {
            margin: 0,
        }
    })
);

export const AssPlayerStartBox: React.FC<IProps> = (props) => {

    const { viewData, fullScreenMode } = props;
    const { t } = useTranslation("assessment");
    const [clientHeight, setClientHeight] = useState<number>(0);

    const titleRef = useRef<any>(undefined);

    useEffect(() => {
        setClientHeight(titleRef.current.clientHeight + 16);
    }, [fullScreenMode]);

    return (
        <>
            <AssPlayerTitleHeader title={viewData.title} ref={titleRef} />
            <Box
                marginTop={2}
                sx={{
                    height: `calc(${fullScreenMode ? "78vh" : "52vh"} - ${clientHeight}px)`,
                    display: "flex",
                    alignItems: viewData.instructions != null ? "start" : "center",
                    justifyContent: "center",
                }}
            >
                <Grid container direction="column" spacing={2}>
                    <Grid>
                        <Grid container direction="row" justifyContent="center" spacing={2}>
                            <Grid>
                                <Box
                                    component="img"
                                    minHeight="180px"
                                    maxHeight="180px"
                                    src={viewData.thumbnailUrl == null ? AppImages.LmsContentTypeEvaluationThumbnail : viewData.thumbnailUrl}
                                />
                            </Grid>
                            {
                                viewData.mode == AssessmentMode.Evaluation && viewData.playerMode == AssessmentPlayerMode.UserReview
                                    ?
                                    <Grid size="grow">
                                        <Box sx={{ maxHeight: fullScreenMode ? "70vh" : "42vh", overflowY: "auto" }}>
                                            <Typography variant="h3">
                                                {t("AssPlayer.StartBox.ReviewSubtitle")}
                                            </Typography>
                                            <ul style={{ marginTop: "20px", paddingLeft: 16, display: "flex", flexDirection: "column", gap: "10px" }}>
                                                <li><Typography variant="body2">{t("AssPlayer.StartBox.CanReviewAnswersText")}</Typography></li>
                                                {
                                                    viewData.eval?.showCorrection &&
                                                    <li><Typography variant="body2">{t("AssPlayer.StartBox.ShowCorrectionText")}</Typography></li>
                                                }
                                                {
                                                    viewData.eval?.showCorrectAnswer &&
                                                    <li><Typography variant="body2">{t("AssPlayer.StartBox.ShowCorrectAnswerText")}</Typography></li>
                                                }
                                            </ul>
                                        </Box>
                                    </Grid>
                                    :
                                    <>
                                        {
                                            viewData.instructions != null &&
                                            <Grid size="grow">
                                                <Box
                                                    sx={{
                                                        maxHeight: fullScreenMode ? `calc(78vh - ${clientHeight}px)` : `calc(52vh - ${clientHeight}px)`,
                                                        overflowY: "auto"
                                                    }}>
                                                    <ContainerMessage dangerouslySetInnerHTML={{ __html: HtmlUtils.textToHtml(viewData.instructions ?? "") }} />
                                                </Box>
                                            </Grid>}
                                    </>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};
